// removed by extract-text-webpack-plugin
module.exports = {"container":"_1GWOLEZEOtkE7XJZSxJX1L","Email":"_3F6DAk9c_87_Q9THbtl64x","Signer":"_38MEWSTohw8cr0pU_Buynh","Icon":"_27EEE-n_FdjFhE5KwETv_c","Title":"_3lhkBlVXuVHn4Ho-Ug2Rdx"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/DocumentVerify/Main/Verify/FeaSigners/styles.css
// module id = 3005
// module chunks = 0